import { GiftCardContextProvider } from "components/Balance/GiftCardContext"
import { GroupCardContextProvider } from "components/Balance/GroupCardContext"
import { CreateAiContextProvider } from "components/CreateAi/CreateAiContext"
import { OtpContextProvider } from "components/OtpStep/OtpContext"
import { CompaniesContextProvider } from "components/PurchasePage/CompaniesContext"
import { GroupPurchasesContextProvider } from "components/PurchasePage/GroupPurchasesContext"
import { PaymentContextProvider } from "components/PurchasePage/Preview/Payment/PaymentContext"
import { PurchaseContextProvider } from "components/PurchasePage/PurchaseContext"
import { QuickPurchaseContextProvider } from "components/QuickPurchasePage/QuickPurchaseContext"
import GlobalContext from "./GlobalContext"

export const ContextProviders = ({ children }) => {
  return (
    <>
      <GlobalContext>
        <QuickPurchaseContextProvider>
          <PurchaseContextProvider>
            <PaymentContextProvider>
              <GiftCardContextProvider>
                <GroupCardContextProvider>
                  <CompaniesContextProvider>
                    <GroupPurchasesContextProvider>
                      <CreateAiContextProvider>
                        <OtpContextProvider>{children}</OtpContextProvider>
                      </CreateAiContextProvider>
                    </GroupPurchasesContextProvider>
                  </CompaniesContextProvider>
                </GroupCardContextProvider>
              </GiftCardContextProvider>
            </PaymentContextProvider>
          </PurchaseContextProvider>
        </QuickPurchaseContextProvider>
      </GlobalContext>
    </>
  )
}
